module.exports = {
    'Send': 'Envoyer'
};



// WEBPACK FOOTER //
// ./src/l10n-messages/fr/alt.js